/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_Local_StorageInputs */

const en_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Storage`)
};

const fr_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage local`)
};

const de_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokaler Speicher`)
};

const it_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione locale`)
};

const ru_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Локальное хранилище`)
};

const es_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento local`)
};

const zh_cn2_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地存储`)
};

const ja_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルストレージ`)
};

const hi_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय भंडारण`)
};

const pt_pt2_new_project_media_source_local_storage = /** @type {(inputs: New_Project_Media_Source_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento local`)
};

/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {New_Project_Media_Source_Local_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_local_storage = /** @type {((inputs?: New_Project_Media_Source_Local_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_Local_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_source_local_storage(inputs)
	if (locale === "de") return de_new_project_media_source_local_storage(inputs)
	if (locale === "it") return it_new_project_media_source_local_storage(inputs)
	if (locale === "ru") return ru_new_project_media_source_local_storage(inputs)
	if (locale === "es") return es_new_project_media_source_local_storage(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_source_local_storage(inputs)
	if (locale === "ja") return ja_new_project_media_source_local_storage(inputs)
	if (locale === "hi") return hi_new_project_media_source_local_storage(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_source_local_storage(inputs)
	return en_new_project_media_source_local_storage(inputs)
});